import { footerWrapper } from "./footer.css";

/**
 * Primary Footer component
 *
 * @example
 * <Footer />
 */

interface FooterProps {
  children: React.ReactNode;
  /**
   * Test Id
   */
  testId?: string;
}

export const Footer = ({
  children,
  testId = "footer-element",
}: FooterProps) => {
  return (
    <footer className={footerWrapper} data-testid={testId}>
      {children}
    </footer>
  );
};
